import classNames from 'classnames';
import React from 'react';

import styles from './more-button.css';
import { MoreIcon } from '../icons/icons';
import { Icon } from '../icon';
import Colors from '../colors';

interface MoreButtonProps {
  /** Adds additional classes to the component. */
  className?: string;
  /** Icon size in pixels */
  size?: number;
  /** divider bar for when used in list items */
  separator?: boolean;
  /** Callback when clicked */
  onClick?: (e: React.MouseEvent) => void;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * A Button with More Icon
 *
 * @param {MoreButtonProps} param
 *
 * @returns JSX.ELEMENT
 */
export const MoreButton = ({
  className,
  size = 22,
  separator,
  onClick,
  'data-testid': dataTestId
}: MoreButtonProps) => (
  <button
    className={classNames([styles.wrapper, separator && styles.separator, className])}
    onClick={onClick}
    data-testid={dataTestId}
  >
    <Icon color={Colors.Scorpion} size={`${size}px`} className={styles.icon}>
      <MoreIcon />
    </Icon>
  </button>
);

export default MoreButton;
